import Layout from "components/Layout";
import Corporations from "./Corporations";
import DowntimeAppDrawerItems from "../components/DowntimeAppDrawerItems";
import DowntimeAppDrawerFooterItems from "../components/DowntimeAppDrawerFooterItems";

export const CorporateSetupDashboard = () => {
    return (
        <Layout
            appDrawerItems={<DowntimeAppDrawerItems />}
            appDrawerFooterItems={
                process.env.REACT_APP_SHOW_DOWNTIME_HELP?.toLocaleLowerCase() === "true" ? (
                    <DowntimeAppDrawerFooterItems />
                ) : null
            }
        >
            <Corporations />
        </Layout>
    );
};
